import React from 'react';
import {Popup, Text} from '../../components';
import {Form} from 'react-final-form';
import {connect} from 'react-redux';


function Create_workspace_popup(props){

    function onSubmit(params){
      props.createWorkspace(params);
    }

    return(
      <Form
        onSubmit={onSubmit}
      >
        {form_props => (
          <form onSubmit={form_props.handleSubmit}>
          <Popup handleClose={props.handleClose} always_open accept_button='Save' accept_button_click={()=>{form_props.form.submit(); form_props.form.reset(); props.handleClose()}} title='New workspace' content={
            <div style={{width:'95vw', maxWidth:'500px'}}>
              <div style={{width:'calc(100% - 40px)', marginLeft:'20px', marginTop:'20px', marginBottom:'20px'}}><Text title='Name' name='name'/></div>
            </div>
          }/>
          </form>
        )}
      </Form>
    )
}


export default connect(ss,dd)(Create_workspace_popup);


function ss(state){
  return{}
}

function dd(dispatch){
  return{
    createWorkspace:(params)=>{dispatch({type:'REQUEST_CREATE_WORKSPACE', payload:params})}
  }
}
